import InfoDetails, { InfoDetailsProps } from './InfoDetails';

export type { InfoDetailsProps };
export default InfoDetails;
